import { useTranslation } from 'react-i18next';

import { useUser } from '~/api/user';
import { Button, Dialog } from '~/components';
import { toast } from '~/utils/toast';

import type { CompletionTabProps as Props } from './types';

import { EditFinancialInfoForm } from '../../EditFinancialInfoForm/EditFinancialInfoForm';

export const FinancialInfoTab = ({ isLastTab, onCompleted }: Props) => {
  const { data: user } = useUser();

  const { t } = useTranslation(['settings']);

  return (
    <>
      <EditFinancialInfoForm onSuccess={() => toast.success({ description: t('settings:alerts.validFinancialInfo') })} user={user} />

      <Dialog.Actions>
        <Button disabled={!user.financial.iban} onClick={onCompleted} type="button">
          {t(`settings:accountCompletionModal.action.${isLastTab ? 'complete' : 'next'}`)}
        </Button>
      </Dialog.Actions>
    </>
  );
};
